import React, { useState } from 'react';
import { connect } from 'react-redux'
import _ from 'lodash'
import { View, StyleSheet, Alert, Platform, Text, TouchableOpacity } from 'react-native'
import { Button, Icon, Image } from 'react-native-elements'
import { addResult, resetResult, undoLast, setPredictor, setMoneyplan, getSATables, getSexyTables } from '../redux/actions'
import { dict as predictors } from '../libs/predictors'
import { dict as moneyplanners } from '../libs/moneyplaners'
import { ImageBackground } from 'react-native-web';

import saOn from '../images/sa-sm.png'
import sexyOn from '../images/sexy-sm.png'
import saOff from '../images/sa-off.png'
import TextZ from './TextZ';

const debounce = (fn) => {
    return _.debounce(fn, 400)
}

const confirm = (title, content, onOk) => {

    if (Platform.OS === 'web') {

        if (window.confirm(`${title}\n\n${content}`)) {
            onOk()
        }
        return;
    }

    Alert.alert(
        title || 'Confirm?',
        content,
        [
          {
            text: 'ยกเลิก',
            onPress: () => {},
            style: 'cancel',
          },
          {text: 'ตกลง', onPress: () => onOk()},
        ],
        {cancelable: false},
      );
}

class Buttons extends React.Component {
    
    componentDidMount() {
        if (this.props.is_firsttime) {
            this.props.planChangeClick()
        }

        this.timer = setInterval(this.interval, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    interval = () => {
        console.log('interval')
        if (this.props.vendor === 'sa') {
            this.props.getSATables(this.props.game_room, this.props.results)
        }
        if (this.props.vendor === 'sexy') {
            this.props.getSexyTables(this.props.game_room, this.props.results)
        }
    }

    SAButton = () => {
        return <TouchableOpacity
            onPress={debounce(this.props.toggleSAClick)} 
            style={StyleSheet.flatten([styles.saButton])}
        >
            <View>
                <Image source={saOn} style={{ flexGrow: 0, width: 30, height:  40, marginLeft: 5}} />
            </View>
            <View  style={{ alignItems: 'stretch', }}>
                <TextZ style={{ fontSize: 12, color: 'white', textAlign: 'center'}}>ห้อง SA</TextZ>
                <TextZ style={{ fontWeight: 'bold', fontSize: 14, color: 'gold', textAlign: 'center'}}>{this.props.game_room}</TextZ>
            </View>
        </TouchableOpacity>;
    }

    SexyButton = () => {
        return <TouchableOpacity
            onPress={debounce(this.props.toggleSAClick)} 
            style={StyleSheet.flatten([styles.saButton])}
        >
            <View>
                <Image source={sexyOn} style={{ flexGrow: 0, width: 30, height:  40, marginLeft: 5}} />
            </View>
            <View  style={{ alignItems: 'stretch', }}>
                <TextZ style={{ fontSize: 12, color: 'white', textAlign: 'center'}}>ห้อง Sexy</TextZ>
                <TextZ style={{ fontWeight: 'bold', fontSize: 14, color: 'gold', textAlign: 'center'}}>{this.props.game_room}</TextZ>
            </View>
        </TouchableOpacity>;
    }

    render() {
        const { addResult, resetResult, undoLast, predictor, moneyplan, planChangeClick, toggleSAClick, vendor, game_room, saTables } = this.props;
        const selectedPredictor = predictors.filter(p => p.module === predictor).pop()
        const selectedMoneyPlaner = moneyplanners.filter(p => p.module === moneyplan).pop()

        if (!selectedPredictor) {
            setPredictor(predictors.filter(p => p.free && p.default).pop().module) 
            return null;
        }
        if (!selectedMoneyPlaner) {
            setMoneyplan(moneyplanners.filter(p => p.free && p.default).pop().module)
            return null;
        }

        const activeSARoom = game_room ? saTables.filter(x => x.name === game_room).pop() : null;

        return <View style={styles.container}>
            <View style={styles.row}>
                {vendor === 'sa' ? this.SAButton() : null}
                {vendor === 'sexy' ? this.SexyButton() : null}
                {vendor === '-' ? <Button
                    containerStyle={StyleSheet.flatten([styles.button, { flex: 1}])}
                    buttonStyle={styles.buttonR}
                    title="เ"
                    titleStyle={{ color: '#444444', width: 0}}
                    icon={<Icon name='file' type='font-awesome' color='#ffffff' size={20} />}
                    onPress={debounce(() => { confirm('เริ่มใหม่', 'ล้างข้อมูลปัจจุบันหรือไม่', resetResult) })} /> : null}
                <Button
                    containerStyle={StyleSheet.flatten([styles.button, { flex: 6}])}
                    buttonStyle={styles.buttonF}
                    title={`สูตร ${selectedPredictor.label} - ${selectedMoneyPlaner.label} `}
                    iconRight
                    icon={<Icon name='chevron-down' type='font-awesome' color='#ffffff' size={16} />}
                    onPress={debounce(planChangeClick)}
                />
                {vendor === '-' ? <Button
                    containerStyle={StyleSheet.flatten([styles.button, { flex: 1}])}
                    buttonStyle={styles.buttonD}
                    title="เ"
                    titleStyle={{ color: '#444444', width: 0}}
                    icon={<Icon name='backspace' color='#ffffff' size={20} />}
                    onPress={debounce(() => { undoLast() })} /> : null}

            </View>
            {vendor === '-' ? <View style={styles.row}>
                <Button
                    containerStyle={styles.button}
                    buttonStyle={styles.buttonP}
                    title="Player"
                    onPress={debounce(() => { addResult('P') })} />
                <Button
                    containerStyle={StyleSheet.flatten([styles.button, { flex: 0.5}])}
                    buttonStyle={styles.buttonT}
                    title="Tie"
                    onPress={debounce(() => { addResult('T') })} />
                <Button
                    containerStyle={styles.button}
                    buttonStyle={styles.buttonB}
                    title="Banker"
                    onPress={debounce(() => { addResult('B') })} />
            </View>  : null}
  

        </View>
    }
}

const mapStateToProps = state => {
    return {
        results: state.results.results,
        predictor: state.settings.predictor,
        game_mode: state.settings.game_mode,
        game_room: state.settings.game_room,
        saTables: state.sa.tables,
        moneyplan: state.settings.moneyplan,
        is_firsttime: state.settings.is_firsttime,
    };
};

const mapDispatchToProps = dispatch => {
    return {
      addResult: (r) => dispatch(addResult(r)),
      resetResult: () => dispatch(resetResult()),
      undoLast: () => dispatch(undoLast()),
      setPredictor: (p) => dispatch(setPredictor(p)),
      setMoneyplan: (p) => dispatch(setMoneyplan(p)),
      getSATables: (r, g) => dispatch(getSATables(r, g)),
      getSexyTables: (r, g) => dispatch(getSexyTables(r, g)),
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Buttons);


const styles = StyleSheet.create({
    container: {
        // flex: 0,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    button: {
        flex: 1,
        padding: 1,
    },
    saButton: { 
        flex: 3, 
        backgroundColor: '#444444' ,
        flexDirection: 'row',
        borderRadius: 3,
        margin: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonSm: {
        // flex: 0,
        padding: 1,
    },
    buttonF: {
        flex: 1,
        backgroundColor: "#444444",
        height: 40
    },
    buttonP: {
        backgroundColor: "rgb(51, 102, 255)",
        height: 70
    },
    buttonT: {
        backgroundColor: "rgb(51, 204, 51)",
        height: 70
    },
    buttonB: {
        backgroundColor: "rgb(255,51,0)",
        height: 70
    },
    buttonR: {
        flex: 1,
        backgroundColor: "#444444",
        height: 40
    },
    buttonD: {
        flex: 1,
        backgroundColor: "#444444",
        height: 40
    },
});
  
  